export default __webpack_public_path__ + "static/media/elec.f306b955.svg";